<template>
  <div class="book">
    <div class="page left">
      <h1>地の巻―兵法の道を大工に喩える</h1>
      <p class="kobun block"><strong>大将は大工の統領として、天下のかねをわきまへ、その国のかねを糾し、其家のかねを知ること、統領の道也。</strong></p>
<p class="genndaibun">大将は、大工の棟梁のように、天下の規則を理解し、国の規則を正し、自らの家の規則を知ることが、統領としての道である。</p>

<p class="kobun block"><strong>大工の統領は堂塔伽藍のすみがねを覚え、宮殿楼閣の指図を知り、人々をつかひ、家々を取立事、大工の棟梁、武家の棟梁も同じ事也。</strong></p>
<p class="genndaibun">大工の棟梁は、寺院や楼閣の設計図を理解し、宮殿や城の建築計画を熟知し、人を指揮して家を建てる。同じように、武士の棟梁も同じ能力を持たなければならない。</p>

<p class="kobun block"><strong>家を立るに、木くばりする事、直にして節もなく、見付のよきを表の柱とし、少ふしありとも直に強きを裏の柱とし、</strong></p>
<p class="genndaibun">家を建てる際には、木材の選別が重要である。まっすぐで節のない、美しい木材は表柱に用い、多少節があってもまっすぐで強い木材は裏柱にする。</p>

<p class="kobun block"><strong>たとひ少弱くとも、節なき木のミさまよきをバ、敷居、鴨居、戸障子と、それぞれにつかひ、</strong></p>
<p class="genndaibun">たとえ少し強度が劣っていても、節のない形の良い木材は、敷居や鴨居、障子などに使う。</p>

<p class="kobun block"><strong>節有とも、ゆがみたりとも、強き木をバ、其家のつよみを見分て、能吟味してつかふにおゐてハ、其家ひさしくくづれがたし</strong></p>
<p class="genndaibun">節があったり多少歪んでいたりしても、強度のある木材を適切な場所に使えば、その家は長く丈夫で崩れにくい。</p>

<p class="kobun block"><strong>又、材木のうちにしても、節おほく、ゆがミてよハきをバ、あしゝろともなし、後には薪ともなすべき事也。</strong></p>
<p class="genndaibun">一方で、節が多く、曲がっていて弱い木材は、家を建てるには向かず、最終的には薪として使われることになる。</p>

<p class="kobun block"><strong>棟梁におゐて、大工をつかふ事、其上中下を知り、或ハ床まわり、或ハ戸障子、或ハ敷居、鴨居、天井已下、それ／＼につかひて、</strong></p>
<p class="genndaibun">棟梁として大工を指導するには、それぞれの職人の技量の高低を見極め、床回りや障子、敷居、鴨居、天井など、適材適所に配置することが重要である。</p>

<p class="kobun block"><strong>あしきにハ、ねだをはらせ、猶悪きにハ、くさびを削せ、人を見分てつかヘバ、其渉行て、手ぎハ能もの也。</strong></p>
<p class="genndaibun">技量の低い者には根太（床の下地）を貼らせ、さらに未熟な者には木の楔を削らせるなど、それぞれの能力に応じた仕事を与えることで、工事はスムーズに進む。</p>

<p class="kobun block"><strong>はかのゆき、手ぎハよきと云所、物ごとをゆるさゞる事、たいゆうを知る事、氣の上中下を知事、いさみをつくると云事、むたいを知と云事、か様の事ども、棟梁の心持に有事也。</strong></p>
<p class="genndaibun">仕事の進捗や技術の良し悪しを判断し、何事もおろそかにせず、組織の調和を理解し、人の気質の高低を見極め、士気を高めること、無謀を避けることなど、これらはすべて棟梁が持つべき心得である。</p>

<p class="kobun block"><strong>兵法の利、かくのごとし。</strong></p>
<p class="genndaibun">兵法の有用性もまた、これと同じである。</p>


      
    </div>
    <div class="page right">
      <div class="video"><div class = "video-container"><iframe  src="https://www.youtube.com/embed/QKmgSUaOUo0" frameborder="0" allowfullscreen></iframe></div></div>
      <h2>地之卷-将兵法之道比作木匠的技艺</h2>
      <p class="kobun block"><strong>大将者，譬如大工之棟梁，能明察天下之规矩，正其国之规矩，知其家之规矩，是为棟梁之道也。</strong></p>
      <p class="genndaibun">统帅如同木匠之首领，应当通晓天下的法则，整顿国家的法则，了解自家的法则，这便是作为统帅的道理。</p>

      <p class="kobun block"><strong>大工之棟梁，须谙堂塔伽蓝之墨规，晓宫殿楼阁之图策，能使人众，成家立业。大工之棟梁，与武家之棟梁，同一道理也。</strong></p>
      <p class="genndaibun">作为木匠的领袖，必须熟悉寺庙佛堂的设计规矩，理解宫殿楼阁的构造图纸，善于指挥工匠，建造房屋。同样的道理，武士的统领也需要具备相同的能力。</p>

      <p class="kobun block"><strong>建家之时，木材分配之法，取直而无节、形美者为表柱，虽有节然直而坚者为里柱。</strong></p>
      <p class="genndaibun">在建造房屋时，选用笔直且无节疤、外观良好的木材作为外柱，即使有些节疤但笔直且坚固的则作为内柱。</p>

      <p class="kobun block"><strong>虽稍弱，然无节且形美者，可用于门槛、横梁、障子等处。</strong></p>
      <p class="genndaibun">即便木材略显柔弱，但若无节疤且外观良好，可用于门槛、横梁、推拉门等部位。</p>

      <p class="kobun block"><strong>虽有节或稍曲，然坚木者，能辨其家之要害，审慎使用，则其家久而不倾。</strong></p>
      <p class="genndaibun">即使木材有节疤或稍有弯曲，但若坚固耐用，若能妥善分配至房屋的关键部位，房屋即可长久稳固，不易坍塌。</p>

      <p class="kobun block"><strong>若材木多节且曲弱者，可为脚手之用，终可作薪焚之。</strong></p>
      <p class="genndaibun">至于那些节疤多、弯曲且不够坚固的木材，可用于搭建临时脚手架，最终可作为柴薪使用。</p>
      
      <p class="kobun block"><strong>棟梁善用匠人，须知其技艺高下，或用于地板，或用于障子，或用于门槛横梁，或用于天井各处，因材施用。</strong></p>
      <p class="genndaibun">作为工匠的领袖，必须了解工匠技艺的高低，分别安排其从事地板、障子、门槛、横梁以及天花等施工工作，各施其才。</p>
      
      <p class="kobun block"><strong>技劣者使铺根太，更劣者使削楔，善辨人能，则工事得以顺遂。</strong></p>
      <p class="genndaibun">手艺不佳者，可安排铺设地板支撑木，更差者可让其削制木楔，若能妥善分工，则工作顺利高效。</p>
      
      <p class="kobun block"><strong>工事顺遂，手法精妙者，皆因不放松戒备，明察体用，知人善任，鼓舞士气，权衡轻重，棟梁当持此心。</strong></p>
      <p class="genndaibun">工程能顺利进行，手法精湛，皆源于不懈怠，明白体用之道，了解不同工匠的能力，善于激励士气，并能合理分配资源，这些都是棟梁应具备的心态。</p>

      <p class="kobun block"><strong>兵法之利，亦如是也。</strong></p>
      <p class="genndaibun">兵法的奥义，亦是如此。</p>

      
    </div>
  </div>
</template>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>
